var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public"},[_c('header',{staticClass:"pub-header w-100 bg-white p-2"},[_c('b-img',{staticClass:"d-block",attrs:{"src":"/img/logo-full.png","fluid":"","alt":_vm.$t('shared.AppLogo')}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }